// @ts-strict-ignore
import * as React from 'react';

import {SpinnerReact} from 'common/components/spinner';
import {SpinnerSize} from 'common/components/spinner/types';

import {SetupGuideContext, Step} from '../types';
import {Scrollable} from '../components/scroll-manager';
import styles from '../index.module.styl';
import {SideNavPhase2} from '../components';
import {Events, ImplementPhase2, WelcomePhase2} from '../steps';

const Content = React.memo((props: {step: Step}) => {
  switch (props.step) {
    case Step.Events:
      return <Events />;
    case Step.Implement:
    case Step.Explore:
      return <ImplementPhase2 />;
    default:
      return <WelcomePhase2 />;
  }
});

export const ModalContentPhase2 = (props) => {
  const {modalManager, step} = React.useContext(SetupGuideContext);
  const {closeModal} = modalManager;
  const wrapperEl = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    if (wrapperEl.current) {
      wrapperEl.current.scrollTo({top: 0});
    }
  }, [step]);

  return (
    <div className={styles.layout}>
      <SideNavPhase2
        onClose={() => {
          closeModal();
        }}
      />
      <Scrollable className={styles.rhs} ref={wrapperEl}>
        {props.isLoading ? (
          <div className={styles.spinner}>
            <SpinnerReact size={SpinnerSize.Large} />
          </div>
        ) : (
          <Content step={step} />
        )}
      </Scrollable>
    </div>
  );
};
